import React, { useContext } from 'react';
import { ClipLoader } from 'react-spinners';
import { ThemeContext } from 'styled-components';
import FormDefault from '~/components/FormDefault';
import Search from '~/components/Search';
import { FormAjuste } from './components/FormAjuste';
import { FormProduct } from './components/FormProduct';
import { useAjusteDeEstoque } from './hooks/useAjusteDeEstoque';
import { Container, ContainerLoader } from './styles';

export const AjusteDeEstoqueContent: React.FC = () => {
  const {
    formTela: { setValue, watch },
    loader,
    showSearch,
    setShowSearch,
    isUpdate,
    setUpdate,
    handleCancelarAjuste,
    onRowClick,
    onSave,
    resetAllFormData,
    resetFormData,
  } = useAjusteDeEstoque();

  const codSeqAjusteEstoque = watch('cod_seq_ajuste_estoque');
  const flgCancelado = watch('flg_cancelado');

  const { colors } = useContext(ThemeContext);

  if (loader) {
    return (
      <ContainerLoader>
        <ClipLoader color={colors.primary} />
      </ContainerLoader>
    );
  }

  return (
    <Container>
      {showSearch && (
        <Search
          codTela={30}
          newData={() => {
            resetAllFormData();
            setUpdate(false);
            setShowSearch(false);
          }}
          onRowClick={onRowClick}
        />
      )}

      {!showSearch && (
        <FormDefault
          codTela={30}
          title="Ajuste de Estoque"
          onSave={async () => {
            await onSave();
          }}
          codigoRegistro={[
            {
              des_campo: 'Código do Ajuste',
              value: Number(codSeqAjusteEstoque),
            },
          ]}
          onCancel={() => {
            setValue('manterDados', false);
            setValue('manterProduto', false);

            resetFormData();
            resetAllFormData();
            setShowSearch(true);
          }}
          isUpdate={isUpdate}
          onNew={() => {
            resetAllFormData();
            setUpdate(false);
            setShowSearch(false);
          }}
          onDelete={handleCancelarAjuste}
          onClearFields={() => {
            resetAllFormData();
            setValue('produtos', { label: '', value: '' });
          }}
          onReturnSearch={() => {
            setShowSearch(true);
            setUpdate(false);
            resetAllFormData();
          }}
          labelButtonTrash="Cancelar Ajuste"
          deleteMessage="Deseja realmente cancelar o registro?"
          isDeactivateDeleteMessage={flgCancelado}
          isSave={!!isUpdate}
        >
          <div className="row" style={{ marginBottom: '20px' }}>
            <FormProduct />
            <FormAjuste />
          </div>
        </FormDefault>
      )}
    </Container>
  );
};
